import type { ISchoolClassroomRepository } from '@/core/domain/school/classroom/ISchoolClassroomRepository'
import type { SchoolClassroomInput } from '@/core/domain/school/classroom/SchoolClassroom'

export class UpdateSchoolClassroomUseCase {
  private readonly schoolClassroomRepository: ISchoolClassroomRepository

  constructor(schoolClassroomRepository: ISchoolClassroomRepository) {
    this.schoolClassroomRepository = schoolClassroomRepository
  }

  async execute(schoolId: number, periodId: number, schoolClassroom: SchoolClassroomInput) {
    return await this.schoolClassroomRepository.updateSchoolClassroom(
      schoolId,
      periodId,
      schoolClassroom
    )
  }
}
